export default __webpack_public_path__ + "static/lalibrairie-m-desktop-3da2999e49cad9f76e32abca64940349.jpg";